import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class PurchaseOrderProcessing
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

  ordersBySupplier(supplierId, startDate, endDate, callback)
  {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/supplier/${supplierId}?startDate=${startDate}&endDate=${endDate}`, callback)
  }
  purchaseOrderDetail(purchaseOrderId, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/purchase-order/${purchaseOrderId}`, callback)
  }
  purchaseOrderDetailDownload(purchaseOrderId, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${purchaseOrderId}/download`, callback)
  }
  purchaseOrderDownloadAdmin(purchaseOrderId, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${purchaseOrderId}/download/admin`, callback)
  }
  orderbyOrderNumber(orderNumber,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/po-processing/orderNumber/${orderNumber}`, callback, 'GET' )
  }

  orderbyCardNumber(cardNumber,startDate,endDate,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/po-processing/giftCardCode/${cardNumber}?startDate=${startDate}&endDate=${endDate}`, callback, 'GET' )
  }


}